module.exports = __webpack_public_path__ + "img/img2.76d56286.jpg";